import { useTranslation } from "react-i18next"

import {
  OtherInitiativeCertificate,
  ScopeCertificate,
  TransactionCertificate,
} from "~/pages/Brand/Certificates/components/templates.ts"

type ScopeCertificateKeys = keyof ScopeCertificate
type TransactionCertificateKeys = keyof TransactionCertificate
type OtherInitiativeCertificateKeys = keyof OtherInitiativeCertificate

type FilteredCertificateKeys =
  | ScopeCertificateKeys
  | TransactionCertificateKeys
  | OtherInitiativeCertificateKeys

type TranslationIndexer = {
  [key in FilteredCertificateKeys]: any
}

type TranslationIndexerStandard = {
  relevantStandard: any
  relevantStandardDesc: any
  validityPeriod: any
  validityPeriodDesc: any
  certifiedEntity: any
  certifiedEntityDesc: any
  productCategories: any
  productCategoriesDesc: any
  certificationBody: any
  certificationBodyDesc: any
}

export const placeHolderTranslations: TranslationIndexer = {
  buyerOfCertifiedProducts: "modal.placeholders.buyerOfCertifiedProducts",
  certificationBody: "modal.placeholders.certificationBody",
  certifiedCompanyLicenseNumber:
    "modal.placeholders.certifiedCompanyLicenseNumber",
  certifiedCompanyName: "modal.placeholders.certifiedCompanyName",
  certifiedWeight: "modal.placeholders.certifiedWeight",
  expiryDate: "modal.placeholders.expiryDate",
  issueDate: "modal.placeholders.issueDate",
  linkedScopeCertificateNumber:
    "modal.placeholders.linkedScopeCertificateNumber",
  name: "modal.placeholders.name",
  processingSteps: "modal.placeholders.processingSteps",
  productCategories: "modal.placeholders.productCategories",
  reference: "modal.placeholders.reference",
  rejectionMessage: "modal.placeholders.rejectionMessage",
  score: "modal.placeholders.score",
  status: "modal.placeholders.status",
  type: "modal.placeholders.type",
  certifiedCompanyAddress: "modal.placeholders.certifiedCompanyAddress",
  productDetails: "modal.placeholders.productDetails",
}

export const labelHolderTranslations: TranslationIndexer = {
  buyerOfCertifiedProducts: "modal.labels.buyerOfCertifiedProducts",
  certificationBody: "modal.labels.certificationBody",
  certifiedCompanyLicenseNumber: "modal.labels.certifiedCompanyLicenseNumber",
  certifiedCompanyName: "modal.labels.certifiedCompanyName",
  certifiedWeight: "modal.labels.certifiedWeight",
  expiryDate: "modal.labels.expiryDate",
  issueDate: "modal.labels.issueDate",
  linkedScopeCertificateNumber: "modal.labels.linkedScopeCertificateNumber",
  name: "modal.labels.name",
  processingSteps: "modal.labels.processingSteps",
  productCategories: "modal.labels.productCategories",
  reference: "modal.labels.reference",
  rejectionMessage: "modal.labels.rejectionMessage",
  score: "modal.labels.score",
  status: "modal.labels.status",
  type: "modal.labels.type",
  certifiedCompanyAddress: "modal.labels.certifiedCompanyAddress",
  productDetails: "modal.labels.productDetails",
}

export const standardRulesTranslations: TranslationIndexerStandard = {
  relevantStandard: "standard.drawer.rules.relevantStandard",
  relevantStandardDesc: "standard.drawer.rules.relevantStandardDesc",
  validityPeriod: "standard.drawer.rules.validityPeriod",
  validityPeriodDesc: "standard.drawer.rules.validityPeriodDesc",
  certifiedEntity: "standard.drawer.rules.certifiedEntity",
  certifiedEntityDesc: "standard.drawer.rules.certifiedEntityDesc",
  productCategories: "standard.drawer.rules.productCategories",
  productCategoriesDesc: "standard.drawer.rules.productCategoriesDesc",
  certificationBody: "standard.drawer.rules.certificationBody",
  certificationBodyDesc: "standard.drawer.rules.certificationBodyDesc",
}

export function useReacti18Translation() {
  const { t } = useTranslation("certificates")

  // t("modal.placeholders.buyerOfCertifiedProducts")
  // t("modal.placeholders.certificationBody")
  // t("modal.placeholders.certifiedCompanyLicenseNumber")
  // t("modal.placeholders.certifiedCompanyName")
  // t("modal.placeholders.certifiedWeight")
  // t("modal.placeholders.expiryDate")
  // t("modal.placeholders.issueDate")
  // t("modal.placeholders.linkedScopeCertificateNumber")
  // t("modal.placeholders.name")
  // t("modal.placeholders.processingSteps")
  // t("modal.placeholders.productCategories")
  // t("modal.placeholders.reference")
  // t("modal.placeholders.rejectionMessage")
  // t("modal.placeholders.score")
  // t("modal.placeholders.status")
  // t("modal.placeholders.type")
  // t("modal.placeholders.certifiedCompanyAddress")
  // t("modal.placeholders.productDetails")

  // t("modal.labels.buyerOfCertifiedProducts")
  // t("modal.labels.certificationBody")
  // t("modal.labels.certifiedCompanyLicenseNumber")
  // t("modal.labels.certifiedCompanyName")
  // t("modal.labels.certifiedWeight")
  // t("modal.labels.expiryDate")
  // t("modal.labels.issueDate")
  // t("modal.labels.linkedScopeCertificateNumber")
  // t("modal.labels.name")
  // t("modal.labels.processingSteps")
  // t("modal.labels.productCategories")
  // t("modal.labels.reference")
  // t("modal.labels.rejectionMessage")
  // t("modal.labels.score")
  // t("modal.labels.status")
  // t("modal.labels.type")
  // t("modal.labels.certifiedCompanyAddress")
  // t("modal.labels.productDetails")

  // t("standard.drawer.rules.relevantStandard")
  // t("standard.drawer.rules.relevantStandardDesc")
  // t("standard.drawer.rules.validityPeriod")
  // t("standard.drawer.rules.validityPeriodDesc")
  // t("standard.drawer.rules.certifiedEntity")
  // t("standard.drawer.rules.certifiedEntityDesc")
  // t("standard.drawer.rules.productCategories")
  // t("standard.drawer.rules.productCategoriesDesc")
  // t("standard.drawer.rules.certificationBody")
  // t("standard.drawer.rules.certificationBodyDesc")

  void t
}
